import React from 'react';
export function ReferralDifference() {
  return <section className="py-20 bg-white border-y border-border" data-id="element-172">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-173">
        <div className="scroll-fade-in-up" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold text-ink mb-6" data-id="element-175">
            The Referral-Only Difference
          </h2>
          <p className="text-xl text-muted leading-relaxed mb-8" data-id="element-176">
            Unlike traditional agencies that prioritize volume and rapid
            scaling, we operate on a strict referral-only model. This isn't
            about exclusivity—it's about quality control and trust.
          </p>
          <p className="text-lg text-muted leading-relaxed" data-id="element-177">
            By accepting new clients solely through trusted networks, we
            eliminate the overhead of traditional sales cycles. This allows us
            to invest 100% of our energy and resources directly into our
            clients' success, ensuring that every project is staffed by our
            top-tier engineers and receives uncompromising attention to detail.
          </p>
        </div>
      </div>
    </section>;
}